import '@ant-design/v5-patch-for-react-19';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ConfigProvider, App as AntdApp } from 'antd';
import frFr from 'antd/lib/locale/fr_FR';

import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { App } from 'app';
// const { App } = lazy(() => import('app'));

import { configureStore } from './configureStore';

import './index.css';
import './assets/styles/variables.css';

const initialState = {};
const store = configureStore(initialState);

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

dayjs.extend(customParseFormat);
dayjs.locale('fr');

root.render(
  <StrictMode>
    <ConfigProvider locale={frFr} theme={{ hashed: false }}>
      <AntdApp>
        <Provider store={store}>
          <Router
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <App />
          </Router>
        </Provider>
      </AntdApp>
    </ConfigProvider>
  </StrictMode>
);
